import React from "react";
import IpdCollectSamplePanel from "./IpdCollectSamplePanel";
import WorkflowPanelModal from "./WorkflowPanelModal";
import { IpdWorkflowDetails } from "./WorkflowPatientDetails";

const IpdWorkflowCollectModal = ({ open, onClose, group, onSampleCollected, onProcessingChange }) => {
  if (!group) return null;

  return (
    <WorkflowPanelModal open={open} onClose={onClose} title="Collect Samples">
      <IpdWorkflowDetails group={group} statusFilter="PENDING" />
      <IpdCollectSamplePanel
        group={group}
        embedded
        onProcessingChange={onProcessingChange}
        onSampleCollected={() => {
          onSampleCollected && onSampleCollected();
          onClose && onClose();
        }}
      />
    </WorkflowPanelModal>
  );
};

export default IpdWorkflowCollectModal;
